import React from 'react';
import { ReactComponent as Done } from "assets/img/svg/done-bullet.svg";
import styles from "./styles.module.scss";
import { ReactComponent as FileIcon } from "assets/img/svg/DocumentLight.svg";
import { ReactComponent as EyeIcon } from "assets/img/svg/eye.svg";
import { fetchAllPostPromisedData } from '../../../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../../../common/constant';
import moment from 'moment';


const ConsentReceived = ({
    consentRecievedDate,
    consentS3Path,
    setAsyncLoader,
    updatedBy
}) => {

    const previewConsentForm = async () => {
        try {
            setAsyncLoader(true);
            const templateUrl = await fetchAllPostPromisedData(`${endpoint.fetchS3Url.getDownloadUrl}?key=${consentS3Path}`, {})
            if (templateUrl?.code === 200 && templateUrl?.data) {
                const resp = await fetch(templateUrl?.data?.url);
                if (resp.ok) {
                    const pdfFile = await resp.blob();
                    const blobUrl = URL.createObjectURL(pdfFile);
                    window.open(blobUrl);

                }
            }

        } catch (err) {
            console.error(err);
        } finally {
            setAsyncLoader(false);
        }
    }
    return (
        <div className={`d-flex justify-content-between ${styles['consent-received-card']}`}>
            <div className='d-flex justify-content-between' style={{ columnGap: '12px' }}>
                <Done />
                <div className='d-flex flex-column'>
                    <div className={`${styles['info-heading']}`}>Consent Received</div>
                    <div className={`${styles['date-time-info']}`}>On {moment(consentRecievedDate).format("DD-MM-YYYY, hh:mm A")} by {updatedBy}</div>
                </div>
            </div>

            <div className={`${styles['preview-consent-cta']}`}>
                <FileIcon className={`${styles['pdf-icon']}`} />
                <span>ParentConsent</span>
                <EyeIcon className="cursor" onClick={previewConsentForm} />
            </div>
        </div>
    );
}

export default ConsentReceived;